import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsUUID, IsEnum, IsBoolean, IsOptional } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { ProgramStatus } from '../../../enums'

export class ListProgramVersionsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'Filter by program ID' })
  @IsUUID()
  @IsOptional()
  programId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by subject ID (via program)' })
  @IsUUID()
  @IsOptional()
  subjectId?: string

  @ApiPropertyOptional({ enum: ProgramStatus, description: 'Filter by status' })
  @IsEnum(ProgramStatus)
  @IsOptional()
  status?: ProgramStatus

  @ApiPropertyOptional({ type: Boolean, description: 'Show only current versions' })
  @IsBoolean()
  @IsOptional()
  isCurrent?: boolean
}
